import React from "react";
import classes from "./OrderStatusCard.module.css";
import { ReactComponent as Register } from "../assets/register-status.svg";
import { ReactComponent as Dorzuar } from "../assets/dorzuar-status.svg";
import { ReactComponent as Refusal } from "../assets/refusal-status.svg";
import { ReactComponent as Transport } from "../assets/transport-status.svg";
import { ReactComponent as Waiting } from "../assets/waiting-status.svg";
import { ReactComponent as Exchange } from "../assets/exchange-status.svg";
import { ReactComponent as Storage } from "../assets/storage-status.svg";
import { ReactComponent as WaitingPickup } from "../assets/waitingpickup-status.svg";
import { ReactComponent as InternationalTransporting } from "../assets/internationaltransporting-status.svg";
import { ReactComponent as PickedUp } from "../assets/pickedUp.svg";
import { ReactComponent as Return } from "../assets/return.svg";

interface Props {
	statusName: string;
	statusCount: number;
	statusColor: string;
	onClick: () => void;
}
// Example: 10 points with bigger swings up & down
const data = [
	{ value: null },
	{ value: null },
	{ value: null },
	{ value: 2 },
	{ value: 5 },
	{ value: 4 },
	{ value: 6 },
	{ value: 11 },
	{ value: 11.2 },
	{ value: 11.3 },
	{ value: 10.5 },
];

export default function OrderStatusCard({
	statusName,
	statusCount,
	statusColor,
	onClick,
}: Props) {
	const lightenColor = (color: string, percent: number) => {
		let num = parseInt(color.replace("#", ""), 16);
		let amt = Math.round(2.55 * percent);

		let R = (num >> 16) + amt;
		let G = ((num >> 8) & 0x00ff) + amt;
		let B = (num & 0x0000ff) + amt;

		R = Math.min(255, Math.max(0, R));
		G = Math.min(255, Math.max(0, G));
		B = Math.min(255, Math.max(0, B));

		return `#${((1 << 24) | (R << 16) | (G << 8) | B)
			.toString(16)
			.slice(1)
			.toUpperCase()}`;
	};

	const shadowColor = lightenColor(statusColor, 30);
	const renderStatusIcon = (color: string) => {
		switch (color) {
			case "#4F16C2":
				return Register;
			case "#8E8E8E":
				return WaitingPickup;
			case "#36B37E":
				return PickedUp;
			case "#0C9AD7":
				return Storage;
			case "#E34850":
				return Refusal;
			case "#D5029A":
				return Return;
			case "#0CAF13":
				return Dorzuar;
			case "#EC132D":
				return Refusal;
			case "#1A82FD":
				return Transport;
			case "#909090":
				return Waiting;
			case "#CC7700":
				return Exchange;
			case "EC132D":
				return Refusal;
			case "#E58731":
				return Storage;
			case "#AF7575":
				return WaitingPickup;
			case "#C3B10D":
				return InternationalTransporting;
			default:
				return Register;
		}
	};

	return (
		<div className={classes.mainContainer} onClick={onClick}>
			<div>
				<h4
					className="text-sm font-semibold"
					style={{ color: statusColor }}
				>
					{statusName}
				</h4>
				<p className="text-2xl font-bold">{statusCount}</p>
			</div>

			<div className="w-full self-start">
				<p style={{ display: "flex", justifyContent: "flex-end" }}>
					{React.createElement(renderStatusIcon(statusColor))}
				</p>
			</div>
		</div>
	);
}
